module.exports = __webpack_public_path__ + "img/GRL.5ac18bfd.svg";